// Vendor
import $ from 'jquery';
import Hammer from 'hammerjs';

// Elements
let $el = $('.js-scroll-carousel');

class ScrollCarousel {
	constructor($el) {
		this.$el = $el;
		this.$scroll = $el.find('> div');

		this.curDown = false;
		this.curYPos = 0;
		this.curXPos = 0;

		if (!window.Modernizr.touch) {
			this.attachEvents();
		}
	}

	attachEvents() {
		var hammertime = new Hammer(this.$scroll.get(0));
		hammertime.on('panleft panright', (ev) => {
			if (!$(ev.target).is('.card-title')) {
				this.$scroll.scrollLeft(this.curXPos - ev.deltaX);
			}
		});

		this.$el.on('mouseup', () => {
			this.curDown = false;
		});

		this.$el.on('mousedown', () => {
			this.curDown = true;
			this.curXPos = this.$scroll.scrollLeft();
		});
	}
}

const _init = () => {
	if ($el.length) {
		$el.each((e, v) => {
			new ScrollCarousel($(v));
		});
	}
};

_init();
